import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues, reduxForm } from 'redux-form/immutable';

// action creators
import {
  appointmentCancel,
  appointmentClose,
  appointmentOpen,
  appointmentUpdate
} from '../../../actions/appointmentActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';
import { initialize } from 'redux-form/immutable';

// constants
const FORM_NAME = 'appointmentNotes';

// components
import BookedAppointmentTooltip from './_BookedAppointmentTooltip';
import OpenAppointmentTooltip from './_OpenAppointmentTooltip';
import CloseAppointmentTooltip from './_CloseAppointmentTooltip';
import { appointmentStatusStyle } from '../../../lib/calendarSharedMethods';
import { convertTime } from '../../../lib/formatDate';

class Appointment extends React.Component {
  render() {
    const { appointment, date } = this.props;
    const startTime = date.startOf('day').add(appointment.get('from'), 'seconds');

    return (
      <React.Fragment>
        <div className='calendar__day__appointment' key={ appointment.get('id') } onClick={ this._handleShow }>
          { this._renderAppointmentLabel() }
          <div className='calendar__day__appointment__right calendar__day__appointment__time'>{ this._formatAppointmentTime(startTime) }</div>
        </div>
        {appointment && this._renderTooltip() }
      </React.Fragment>
    );
  }

  // private

  _handleCancelAppointment  = this._handleCancelAppointment.bind(this);
  _handleCloseAppointment   = this._handleCloseAppointment.bind(this);
  _handleOpenAppointment    = this._handleOpenAppointment.bind(this);
  _handleClose              = this._handleClose.bind(this);
  _handleShow               = this._handleShow.bind(this);
  _renderAppointmentTime    = this._renderAppointmentTime.bind(this);
  _handleNotesSubmit        = this._handleNotesSubmit.bind(this);
  _renderError              = this._renderError.bind(this);

  _formatAppointmentTime(date) {
    let value;

    if (date.format('mm') !== '00') {
      value = date.format('h:mm a');
    } else {
      value = date.format('h a');
    }

    return value;
  }

  _getTooltipId() {
    const { appointment } = this.props;

    return `appointmentDetailsTooltip${appointment.get('id')}`;
  }

  _handleCancelAppointment() {
    const { appointment, formValues, dispatch, cancelAppointment } = this.props;

    const id = appointment.get('id');
    const notes = (formValues || Immutable.Map()).get(`notes${id}`);

    if (notes === '' || !notes) {
      dispatch(change(FORM_NAME, 'hasError', true));
      return false;
    }

    return cancelAppointment(appointment.get('id'), { notes  });
  }

  _handleCloseAppointment() {
    const { appointment, closeAppointment } = this.props;

    return closeAppointment(appointment.get('id'));
  }

  _handleOpenAppointment() {
    const { appointment, openAppointment } = this.props;

    openAppointment(appointment.get('id'));
  }

  _handleClose() {
    const { hideTooltip } = this.props;

    hideTooltip(this._getTooltipId());
  }

  _handleShow() {
    const {  showTooltip } = this.props;

    this._initForm();

    showTooltip(this._getTooltipId());
  }

  _initForm() {
    const { appointment, dispatch } = this.props;

    const form = {};

    form[`notes${appointment.get('id')}`] = appointment.get('notes');
    dispatch(change(FORM_NAME, 'hasError', false));
    dispatch(initialize(FORM_NAME, form, { keepDirty: true }));
  }

  _renderAppointmentLabel() {
    const { appointment } = this.props;
    const element = (
      <div className={ `calendar__day__appointment__left calendar__day__appointment__status ${appointmentStatusStyle(appointment.get('status'))}` }>
        {this._statusText(appointment.get('status'))}
      </div>
    );

    return element;
  }

  _statusText(status) {
    const { appointment } = this.props;
    const rep = ((this.props.rep || Immutable.Map()).get('data') || Immutable.Map()).get(appointment.get('rep')) || Immutable.Map();

    if (status === 'confirmed' || status === 'booked') {
      return (
        <React.Fragment>
          <div className={ 'calendar__day__appointment__rep-name' }>{rep.get('name')}</div>
          <div className={ 'calendar__day__appointment__rep-company' }>{rep.get('company')}</div>
        </React.Fragment>
      );
    }
    return {
      opened: 'Open',
      closed: 'Closed',
      confirmed: 'Confirmed',
      booked: 'Booked'
    }[status];
  }

  _renderAppointmentTime() {
    const { appointment, date } = this.props;
    const startTime = this._formatAppointmentTime(date);
    const endTime = convertTime(appointment.get('to'));

    let segment;

    switch (appointment.get('segmentNumber')) {
      case 1:
        segment = 'BREAKFAST';
        break;
      case 2:
        segment = 'LUNCH';
        break;
      case 3:
        segment = 'SNACK';
        break;
      default:
        segment = 'BREAKFAST';
        break;
    }

    return (
      <div className='calendar__day__appointment-tooltip__time'>
        { `${segment}: ${startTime} - ${endTime}` }
      </div>
    );
  }

  _renderTooltip() {
    const { appointment, date, loading } = this.props;
    const rep     = ((this.props.rep || Immutable.Map()).get('data') || Immutable.Map()).get(appointment.get('rep')) || Immutable.Map();
    const status  = appointment.get('status');
    const caterer = appointment.get('caterer') || Immutable.Map();
    let element = null;

    if (status === 'booked' || status === 'confirmed') {
      element = (
        <BookedAppointmentTooltip appointment={ appointment }
          caterer={ caterer }
          date={ date }
          id={ this._getTooltipId() }
          loading={ loading }
          onHandleCancelAppointment={ this._handleCancelAppointment }
          onHandleClose={ this._handleClose }
          onHandleNotesSubmit={ this._handleNotesSubmit }
          renderAppointmentTime={ this._renderAppointmentTime }
          renderError={ this._renderError }
          rep={ rep } />
      );
    } else if (status === 'opened') {
      element = <OpenAppointmentTooltip appointment={ appointment }
        date={ date }
        id={ this._getTooltipId() }
        loading={ loading }
        onHandleClose={ this._handleClose }
        onHandleCloseAppointment={ this._handleCloseAppointment }
        onHandleNotesSubmit={ this._handleNotesSubmit }
        renderAppointmentTime={ this._renderAppointmentTime } />;
    } else if (status === 'closed') {
      element = <CloseAppointmentTooltip appointment={ appointment }
        date={ date }
        id={ this._getTooltipId() }
        loading={ loading }
        onHandleClose={ this._handleClose }
        onHandleNotesSubmit={ this._handleNotesSubmit }
        onHandleOpenAppointment={ this._handleOpenAppointment }
        renderAppointmentTime={ this._renderAppointmentTime } />;
    }

    return element;
  }

  _handleNotesSubmit(e) {
    e.preventDefault();

    const { appointment, formValues, updateAppointment } = this.props;
    const id = appointment.get('id');
    const notes = (formValues || Immutable.Map()).get(`notes${id}`);

    updateAppointment({
      id:     id,
      notes
    });
  }

  _renderError() {
    const { formValues, appointment } = this.props;
    const id = appointment.get('id');
    const notes = (formValues || Immutable.Map()).get(`notes${id}`);

    if (formValues && formValues.get('hasError') || notes === '') {
      return <i className='fa fa-exclamation-circle calendar-tooltip__note--error' />;
    }

    return null;
  }
}

Appointment.propTypes = {
  appointment:        PropTypes.instanceOf(Immutable.Map),
  cancelAppointment:  PropTypes.func.isRequired,
  closeAppointment:   PropTypes.func.isRequired,
  date:               PropTypes.instanceOf(moment),
  formValues:         PropTypes.instanceOf(Immutable.Map),
  hideTooltip:        PropTypes.func.isRequired,
  loading:            PropTypes.bool,
  openAppointment:    PropTypes.func.isRequired,
  rep:                PropTypes.instanceOf(Immutable.Map),
  showTooltip:        PropTypes.func.isRequired,
  updateAppointment:  PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    rep: state.get('rep'),
    formValues: getFormValues(FORM_NAME)(state),
    tooltip: state.get('tooltip')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cancelAppointment: (id, update) => {
      dispatch(appointmentCancel({ id: id, update }));
    },

    closeAppointment: (id) => {
      dispatch(appointmentClose({ id: id }));
    },

    openAppointment: (id) => {
      dispatch(appointmentOpen({ id: id }));
    },

    hideTooltip: (id) => {
      dispatch(tooltipHide({ id: id }));
    },

    showTooltip: (id) => {
      dispatch(tooltipShow({ id: id }));
    },

    updateAppointment: (params) => {
      dispatch(appointmentUpdate(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME }
  )(Appointment)
);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Appointment.jsx